// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';
import searchReducer from './reducers/searchSlice';
import filterReducer from './reducers/filterReducer';
import userReducer from './reducers/userReducer';
import carReducer from './reducers/carReducer';
import scheduleReducer from './reducers/scheduleReducer';

// Enable Map and Set support for Immer
enableMapSet();

const store = configureStore({
    reducer: {
        search: searchReducer, // Ensure this is correctly set up
        filter: filterReducer,
        user: userReducer,
        car: carReducer,
        schedule: scheduleReducer,
        // other reducers
    },
    // Add middleware to properly serialize/deserialize the Set
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false // Disable serializable check for Sets
        }),
});

export default store;
